import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost } from "api/restUtil";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { getCommaNumber, getDateStr, getDateToIsoDate, getIsoDateToDisplay, getNowTimeHmsS, getTimeHms, getTodayStr, isEmpty, isValidDate, isValidHm } from "js/common";
import SendCompleteModal from "./SendCompleteModal";
import SendDelayModal from "./SendDelayModal";
import { getResultMsg } from "js/order";
import OrderCancelReqModal from "./claim/OrderCancelReqModal";
import OrderAdminCancelReqModal from "./claim/OrderAdminCancelReqModal";
import OrderReturnReqModal from "./claim/OrderReturnReqModal";
import OrderReturnHoldModal from "./claim/OrderReturnHoldModal";
import OrderReturnRejectModal from "./claim/OrderReturnRejectModal";
import DeliveryCallbackModal from "./DeliveryCallbackModal";
import SendReadyModal from "./SendReadyModal";

/**
 * 상품 상세 팝업
 */
function OrderDetailModal (props) {

	const { isOpen, onClose, initData, modalId, title } = props;
	const [ origData, setOrigData ] = useState([]);	// 원본 데이터
	const [ data, setData ] = useState([]);	// 화면 처리용 데이터 (원본을 flat하게 변경)
	const [ isOpenCompletePopup, setIsOpenCompletePopup ] = useState(false);	// 구매확정 팝업 표시
	const completeData = useRef(null);
	const [ isOpenDelayPopup, setIsOpenDelayPopup ] = useState(false);	// 발송지연 팝업 표시
	const [delayInfo, setDelayInfo] = useState({});	// 발송 지연 정보
	
	const [ isOpenCancelReqPopup, setIsOpenCancelReqPopup ] = useState(false);	// 취소 요청팝업 표시
	const cancelReqInfo = useRef(null);
	// const [cancelReqInfo, setCancelReqInfo] = useState({});	// 취소 요청 정보 => 이거.... useRef로 해도 될거 같은데..
	const [ isOpenAdminCancelReqPopup, setIsOpenAdminCancelReqPopup ] = useState(false);	// 직권취소 요청팝업 표시
	const adminCancelReqInfo = useRef(null);
	// const [adminCancelReqData, setAdminCancelReqData] = useState({});	// 직권 취소 요청 정보

	const [ isOpenReturnReqPopup, setIsOpenReturnReqPopup ] = useState(false);	// 반품 요청 팝업 표시
	const returnReqInfo = useRef(null);	// 반품 요청 정보

	const [ isOpenReturnHoldPopup, setIsOpenReturnHoldPopup ] = useState(false);	// 반품 보류 팝업 표시
	const returnHoldInfo = useRef(null);	// 반품 보류 정보
	
	const [ isOpenReturnRejectPopup, setIsOpenReturnRejectPopup ] = useState(false);	// 반품 거부 팝업 표시
	const returnRejectInfo = useRef(null);	// 반품 거부 정보

	const [ isOpenSendReadyPopup, setIsOpenSendReadyPopup] = useState(false);	// 발송처리(배송준비중) 팝업 표시
	const sendReadyInfo = useRef(null);	// 발송처리(배송준비중) 정보

	const [ isOpenDeliveryCallbackPopup, setIsOpenDeliveryCallbackPopup] = useState(false);	// 배송 콜백 팝업 표시
	const deliveryCallbackInfo = useRef(null);	// 배송 콜백 정보

	useEffect(() => {
		if(!isOpen) {
			setData([]);
			
			return;
		};

		if(isOpen && initData && initData.orderId) getOrderDetail(initData);

	}, [isOpen, initData]);
	
	// 기존 정보 조회
	const getOrderDetail = async (orderData) => {
		const result = await sendGet("/api/order/" + orderData.orderId, {});
		if(result.respCode == "SUCCESS") {
			
			if(result.data == null || result.data.data == null) {
				setData([]);
				return;
			}
			
			// 번호 매기고, 전체 취소 수량
			const idxData = result.data.data.map((d, idx) => ({
				...d
				, ordr: idx+1
				, totalCancelQuantity: d.completedClaims?.map(c => c.requestQuantity).reduce((acc, c) => acc += c)
			}));

			// 원본 데이터 저장
			setOrigData(idxData);
			// Object를 flat하게..
			const newData = idxData.map(d => makeFlatData(d));

			setData(newData);
		}
	}

	const makeFlatData = (data, prefix = "") => {
		const keys = Object.keys(data);
		const newData = {};
		for(const key of keys) {
			const val = data[key];

			if(typeof val === "object") {
				if(val == null) {
					newData[prefix + key] = val;
				} else if(Array.isArray(val)) {
					newData[prefix + key] = val;
				} else {
					// 순수 object
					const subData = makeFlatData(val, prefix + key + "_");
					Object.assign(newData, subData);
				}
			} else {
				newData[prefix + key] = val;
			}
		}
		return newData;

	}

	// 발주 확인 처리
	const productOrderConfirm = async (productOrderId) => {
		let productOrderIds = null;
		if(productOrderId) {
			productOrderIds = data
				.filter(d => d.productOrder_productOrderId === productOrderId)
				.filter(d => d.productOrder_productOrderStatus === "PAYED" && d.productOrder_placeOrderStatus !== "OK")
				.map(d => d.productOrder_productOrderId);
		} else {
			// 결제 완료 상태인 상품 주문 번호
			productOrderIds = data
				.filter(d => d.productOrder_productOrderStatus === "PAYED" && d.productOrder_placeOrderStatus !== "OK")
				.map(d => d.productOrder_productOrderId);
		}
		if(productOrderIds == null || productOrderIds.length === 0) {
			alert("발주 가능한 상품주문이 없습니다.");
			return;
		}
		
		if(!window.confirm("발주 처리 하시겠습니까?")) return;

		const result = await sendPost("/api/order/confirm", {productOrderIds: productOrderIds});
		if(result.respCode === "SUCCESS") {
			if(productOrderIds.length === result.data.data.successProductOrderInfos.length) {
				alert("발주확인 처리 되었습니다.");
				getOrderDetail(initData)
			} else {
				const successList = result.data.data.successProductOrderInfos;
				const msg = getResultMsg(result.data.data);

				alert(msg);
				if(successList.length > 0) {
					getOrderDetail(initData)
				}

			}
		}
	}

	// 상품 발송
	const productOrderDispatch = async (productOrderId) => {
		let productOrderIds = null;
		if(productOrderId) {
			productOrderIds = data
				.filter(d => d.productOrder_productOrderId === productOrderId)
				.filter(d => d.productOrder_productOrderStatus === "PAYED")
				.map(d => d.productOrder_productOrderId);
		} else {
			// 결제 완료 상태인 상품 주문 번호
			productOrderIds = data
				.filter(d => d.productOrder_productOrderStatus === "PAYED")
				.map(d => d.productOrder_productOrderId);
		}
		if(productOrderIds == null || productOrderIds.length === 0) {
			alert("발송 가능한 상품주문이 없습니다.");
			return;
		}
		
		// 픽업이면 그냥 처리 하는데 발송이면 송장번호 넣도록 해야 함
		if(data[0].productOrder_expectedDeliveryMethod === "DELIVERY") {
			// 배송 상품은 송장 번호 입력 팝업
			sendReadyInfo.current = {productOrderIds: productOrderIds, deliveryMethod: "DELIVERY"}
			setIsOpenSendReadyPopup(true);
			return;
		}

		if(!window.confirm("발송 처리 하시겠습니까?")) return;

		const dispatchDate = getTodayStr() + "T" + getNowTimeHmsS() + "+09:00";

		// const deliveryMethod = origData.

		const deliveryMethod = origData[0].productOrder.expectedDeliveryMethod

		const dispatchProductOrders = productOrderIds.map(d => ({
			productOrderId: d,
			dispatchDate: dispatchDate,
			deliveryMethod: deliveryMethod,
			deliveryCompanyCode: deliveryMethod === "DELIVERY" ? "SNOWFOXFLOWER" : "",
			trackingNumber: deliveryMethod === "DELIVERY" ? d : "", // 이거는 추후에 변경될지도.. 일단은 상품주문번호로 설정
		}));


		const result = await sendPost("/api/order/dispatch", {dispatchProductOrders: dispatchProductOrders});
		if(result.respCode === "SUCCESS") {
			if(productOrderIds.length === result.data.data.successProductOrderIds.length) {
				alert("발송 처리 되었습니다.");
				getOrderDetail(initData)
			} else {
				const successList = result.data.data.successProductOrderIds;
				
				const msg = getResultMsg(result.data.data);

				alert(msg);
				if(successList.length > 0) {
					getOrderDetail(initData)
				}
			}
		}
	}
	// 상품 발송 지연 팝업 표시
	const productOrderDispatchDelayPopup = (d) => {
		setDelayInfo({productOrderId: d.productOrder_productOrderId, dispatchDueDt: getTodayStr()});
		setIsOpenDelayPopup(true);
	}

	// 구매확정 처리 팝업 표시 (픽업상품 배송완료)
	const showProductOrderSendCompletePopup = (d) => {
		completeData.current = d;
		setIsOpenCompletePopup(true);
	}
	// 배송 주문 출고완료
	const productOrderReleaseComplete = (d) => {
		deliveryCallbackInfo.current = {productOrderId: d, type: "RELEASE_COMPLETION"};
		setIsOpenDeliveryCallbackPopup(true);
	}
	// 배송 주문 배송완료
	const productOrderDeliveryComplete = (d) => {
		deliveryCallbackInfo.current = {productOrderId: d, type: "DELIVERY_COMPLETION"};
		setIsOpenDeliveryCallbackPopup(true);
	}

	
	// 취소 팝업 표시
	const showProductOrderCancelReqPopup = (productOrderId) => {
		cancelReqInfo.current = {productOrderId: productOrderId};
		setIsOpenCancelReqPopup(true);
	}

	// 직권취소요청 팝업 표시
	const showProductOrderAdminCancelReqPopup = (productOrderId) => {
		adminCancelReqInfo.current = {productOrderId: productOrderId};
		setIsOpenAdminCancelReqPopup(true);
	}

	// 취소 승인
	const productOrderCancelApprove = async (productOrderId) => {
		if(!window.confirm("취소요청을 승인하시겠습니까?")) return;
		const result = await sendPost("/api/order/claim/cancel/approve/" + productOrderId);
		
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("취소 승인 되었습니다.");
				getOrderDetail(initData);
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
		}
	}

	// 반품 요청 팝업 표시
	const showProductOrderReturnReqPopup = (productOrderId) => {
		returnReqInfo.current = {productOrderId: productOrderId};
		setIsOpenReturnReqPopup(true);
	}

	// 반품 승인
	const productOrderReturnApprove = async (productOrderId) => {
		if(!window.confirm("반품을 승인하시겠습니까?")) return;
		const result = await sendPost("/api/order/claim/return/approve/" + productOrderId);
		
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("반품 승인 되었습니다.");
				getOrderDetail(initData);
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
		}
	}

	// 반품 보류 팝업 표시
	const showProductOrderReturnHoldPopup = (productOrderId) => {
		returnHoldInfo.current = {productOrderId: productOrderId};
		setIsOpenReturnHoldPopup(true);
	}
	
	// 반품 거부(철회) 팝업 표시
	const productOrderReturnRejectPopup = (productOrderId) => {
		returnRejectInfo.current = {productOrderId: productOrderId};
		setIsOpenReturnRejectPopup(true);
	}

	// 반품 보류 해제
	const productOrderReturnHoldRelease = async (productOrderId) => {
		if(!window.confirm("반품보류를 해제하시겠습니까?")) return;
		const result = await sendPost("/api/order/claim/return/hold/release/" + productOrderId);
		
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("반품보류가 해제 되었습니다.");
				getOrderDetail(initData);
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
		}
	}


	// 팝업에서 처리 이후 수행.
	const afterOrderProcess = (successCnt, failCnt, type) => {
		if(successCnt && successCnt > 0) {
			getOrderDetail(initData)
		}

		if(!failCnt || failCnt === 0) {
			if(type === "complete") setIsOpenCompletePopup(false);
			else if(type === "sendReady") setIsOpenSendReadyPopup(false);
			else if(type === "delay") setIsOpenDelayPopup(false);
			else if(type === "cancelReq") setIsOpenCancelReqPopup(false);
			else if(type === "adminCancelReq") setIsOpenAdminCancelReqPopup(false);
			else if(type === "returnReq") setIsOpenReturnReqPopup(false);
			else if(type === "returnHold") setIsOpenReturnHoldPopup(false);
			else if(type === "returnReject") setIsOpenReturnRejectPopup(false);
		}
	}

	// 원본 데이터목록에서 flat데이터의 원본을 찾기
	const getOrigDataInfo = (flatData) => {
		return origData.find(d => d.ordr === flatData.ordr);
	}

	// currentClaim하위의 object를 가져오기 (이게 return일수도 cancel일수도 있어서..)
	const getCurrentClaimType = (d) => {
		const currClaim = getOrigDataInfo(d).currentClaim;
		if(!currClaim) return null;
		return Object.keys(currClaim)[0];
	}

	const getCurrentClaim = (d) => {
		const claimType = getCurrentClaimType(d);
		if(claimType == null) return null;

		return getOrigDataInfo(d).currentClaim[claimType];

	}


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "1000px", height: "600px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="table-buttons mg-t-10 mg-b-10">
								{/* 결제완료 이고 발주확인 안된 데이터가 1개라도 있을때만 전체 발주 나오게.. */}
								{data.some(d => d.productOrder_productOrderStatus === "PAYED" && d.productOrder_placeOrderStatus !== "OK") && (
									<BasicButton label="전체발주확인" className="btn-save" onClick={() => productOrderConfirm()} />
								)}
								{/* 결제완료인 데이터가 1개라도 있을때 전체 발송 */}
								{data.some(d => d.productOrder_productOrderStatus === "PAYED") && (
									<BasicButton label="전체발송" className="btn-save" onClick={() => productOrderDispatch()} />
								)}
								{/* 전체 구매확정은... 일단 보류... */}
							</div>

							<div className="sub-title">주문정보</div>
							{data && data.length > 0 && (
								<div className="grid-table" style={{gridTemplateColumns: "1fr 2fr 1fr 2fr"}}>
									<div className="th">주문번호</div>
									<div className="td">{data[0].order_orderId}</div>
									<div className="th">결제 일시</div>
									<div className="td">{getIsoDateToDisplay(data[0].order_paymentDate)}</div>
									<div className="th">주문자명</div>
									<div className="td">{data[0].order_ordererName}</div>
									<div className="th">주문자전화번호</div>
									<div className="td">{data[0].order_ordererTel}</div>

									<div className="th">배송/픽업</div>
									<div className="td">{data[0].productOrder_expectedDeliveryMethod === "VISIT_RECEIPT" ? "픽업" : "배송"}</div>
									<div />
									<div />


									{data[0].productOrder_deliveryAttributeType === "QUICK" && (	// 배송일때
										<>
											<div className="th">수령자명</div>
											<div className="td">
												{data[0].productOrder_shippingAddress_name}
											</div>
											<div className="th">수령자연락처</div>
											<div className="td">
												{data[0].productOrder_shippingAddress_tel1}
											</div>
											<div className="th">배송지</div>
											<div className="td">
												[{data[0].productOrder_shippingAddress_zipCode}]
												<br/>
												{data[0].productOrder_shippingAddress_baseAddress}
												<br/>
												{data[0].productOrder_shippingAddress_detailedAddress}
											</div>
											<div className="th">배송 메모</div>
											<div className="td">{data[0].productOrder_shippingMemo}</div>

											<div className="th">수령 위치</div>
											<div className="td">{data[0].productOrder_shippingAddress_pickupLocationType}</div>
											<div className="td" style={{gridColumn: "span 2"}}>{data[0].productOrder_shippingAddress_pickupLocationContent}</div>

											<div className="th">출입 방법</div>
											<div className="td">{data[0].productOrder_shippingAddress_entryMethod}</div>
											<div className="td" style={{gridColumn: "span 2"}}>{data[0].productOrder_shippingAddress_entryMethodContent}</div>


											<div className="th">배송비구분</div>
											<div className="td">{data[0].productOrder_deliveryPolicyType}</div>
											<div className="th">배송비 형태</div>
											<div className="td">{data[0].productOrder_shippingFeeType}</div>
										</>
									)}
									<div className="th">총 결제금액</div>
									<div className="td">
										{
											getCommaNumber(
												(data[0].order_chargeAmountPaymentAmount ?? 0)	// 충전금
												+ (data[0].order_checkoutAccumulationPaymentAmount ?? 0)	// 네이버페이 적립급
												+ (data[0].order_generalPaymentAmount ?? 0)	// 일반 결제 수단
												+ (data[0].order_naverMileagePaymentAmount ?? 0)	// 네이버페이 포인트
											)
										}
									</div>
									<div className="th">결제 수단</div>
									<div className="td">{data[0].order_paymentMeans}</div>
								</div>
							)}
							<div className="sub-title">상품 주문 정보</div>

							{data && data.length > 0 && data.map((d, idx) => (
								<Fragment key={"prdordr_" + idx}>
									<div className="mg-t-10" />
									<div className="grid-table" style={{gridTemplateColumns: "repeat(2, 1fr 2fr)"}}>
									
										<div className="th">No</div>
										<div className="td">{d.ordr}</div>

										<div className="th">상품주문번호</div>
										<div className="td">{d.productOrder_productOrderId}</div>

										<div className="th">채널상품번호</div>
										<div className="td">{d.productOrder_productId}</div>

										<div className="th">상품명</div>
										<div className="td">{d.productOrder_productName}</div>

										<div className="th">상품옵션</div>
										<div className="td">{d.productOrder_productOption}</div>

										<div className="th">수량</div>
										<div className="td">
											{d.productOrder_quantity}
											{d.totalCancelQuantity && (
												<>
													&nbsp; (취소: {d.totalCancelQuantity})
												</>
											)}
										</div>

										<div className="th">주문상태</div>
										<div className="td">
											{d.productOrder_productOrderStatus}
											{d.productOrder_productOrderStatus === "DELIVERING" && (
												isEmpty(d.delivery_deliveryStatus) ? "(배송준비중)" : "(" + d.delivery_deliveryStatus + ")"
											)}
										</div>
										
										<div className="th">발주상태</div>
										<div className="td">{d.productOrder_placeOrderStatus}</div>

										<div className="th">주문처리</div>
										<div className="td orderProcBtn" style={{gridColumn: "span 3"}}>
											<>
												{d.productOrder_productOrderStatus === "PAYED" && d.productOrder_placeOrderStatus !== "OK" && (
													<BasicButton label="발주확인" className="list-button btn-mod" onClick={() => productOrderConfirm(d.productOrder_productOrderId)}/>
												)}
												
												{d.productOrder_productOrderStatus === "PAYED" ? (
													<>
														<BasicButton label="발송처리" className="list-button btn-mod" onClick={() => productOrderDispatch(d.productOrder_productOrderId)}/>
														<BasicButton label="발송지연" className="list-button btn-copy" onClick={() => productOrderDispatchDelayPopup(d)}/>
													</>
												) : d.productOrder_productOrderStatus === "DELIVERING" ? (
													<>
														{d.productOrder_expectedDeliveryMethod === "DELIVERY" && (
															<>
																{d.delivery_deliveryStatus !== "COLLECT_CARGO" && d.delivery_deliveryStatus !== "DELIVERY_COMPLETION" && (
																	// 배송 상세가 출고완료, 배송완료가 아니면 표시
																	<BasicButton label="출고완료" className="list-button btn-mod" onClick={() => productOrderReleaseComplete(d.productOrder_productOrderId)}/>
																)}
																{d.delivery_deliveryStatus !== "DELIVERY_COMPLETION" && (
																	// 배송 상세가 배송완료가 아니면 표시
																	<BasicButton label="배송완료" className="list-button btn-copy" onClick={() => productOrderDeliveryComplete(d.productOrder_productOrderId)}/>
																)}
															</>
														)}
														{d.productOrder_expectedDeliveryMethod === "VISIT_RECEIPT" && (
															<>
																<BasicButton label="픽업완료" className="list-button btn-add" onClick={() => showProductOrderSendCompletePopup(d)}/>
															</>
														)}
													</>
												) : (<></>)}

												{/* <BasicButton label="취소 승인" className="list-button btn-save" onClick={() => productOrderCancelApprove(d.productOrder_productOrderId)}/> */}
												
											</>
										</div>

										<div className="th">클레임상태</div>
										<div className="td" style={{gridColumn: "span 3"}}>
											{d.completedClaims && d.completedClaims.map((cc, idx) => (
												<Fragment key={"completedClaim_" + idx}>
													{idx > 0 && (
														<br />
													)}
													{cc.claimStatus} ({cc.requestQuantity})
												</Fragment>
											))}
											{getCurrentClaim(d) && [getCurrentClaim(d)]?.map( (cur, idx) => (
												<Fragment key={"currentClaim_" + idx}>
													{!d.completedClaims?.some(cc => cc.claimId === cur.claimId) && (
														<>
															{cur.claimStatus} ({cur.requestQuantity})
															{cur.holdbackStatus === "HOLDBACK" && (
																<>
																	&nbsp; - 보류 (사유: {cur.holdbackReason})
																	&nbsp; {cur.claimDeliveryFeeDemandAmount ?? ""}
																	&nbsp; {cur.claimDeliveryFeePayMethod ?? ""}
																	&nbsp; {cur.etcFeeDemandAmount ?? ""}
																	&nbsp; {cur.etcFeePayMethod ?? ""}
																</>
															)}
														</>
													)}
												</Fragment>
											))}
											{/* {getOrigDataInfo(d).currentClaim && Object.keys(getOrigDataInfo(d).currentClaim).map(type => (
												<>
													{!d.completedClaims?.some(cc => cc.claimId === d[`currentClaim_${type}_claimId`]) && (
														<>
															{d[`currentClaim_${type}_claimStatus`]} ({d[`currentClaim_${type}_requestQuantity`]})

															{d[`currentClaim_${type}_holdbackStatus`] === "HOLDBACK" && (
																<>
																	&nbsp; - 보류 (사유 : {d[`currentClaim_${type}_holdbackReason`]})
																</>
															)}
														</>
													)}
												</>
											))} */}
											{/* {getOrigDataInfo(d).currentClaim && !d.completedClaims?.some(cc => cc.claimId === d.currentClaim_cancel_claimId) && (
												<>
													{d.currentClaim_cancel_claimStatus} ({d.currentClaim_cancel_requestQuantity})
												</>
											)}
											{getOrigDataInfo(d).currentClaim && !d.completedClaims?.some(cc => cc.claimId === d.currentClaim_return_claimId) && (
												<>
													{d.currentClaim_return_claimStatus} ({d.currentClaim_return_requestQuantity})
												</>
											)} */}
										</div>

										<div className="th">클레임처리</div>
										<div className="td orderProcBtn" style={{gridColumn: "span 3"}}>
											<>
												{d.productOrder_productOrderStatus === "PAYED" ? (
													<>
														<BasicButton label="취소" className="list-button btn-cancel" onClick={() => showProductOrderCancelReqPopup(d.productOrder_productOrderId)}/>
													</>
												) : d.productOrder_productOrderStatus === "DELIVERING" ? (
													<>
																
														{/* 상태에 따른 처리를 해야 되는데.. */}
														{/*
														currentClaim이 없거나 
														currentClaim.cancel.claimStatus가 CANCEL_DONE 이거나 (사용자는 1번은 부분취소가 되더라.. )
														currentClaim.return.claimStatus가 RETURN_REJECT 일때.. (반품 요청 취소이므로 다시 신철 가능)

														*/}
														{(!getOrigDataInfo(d).currentClaim
														|| d.currentClaim_cancel_claimStatus === "CANCEL_DONE"
														|| d.currentClaim_return_claimStatus === "RETURN_REJECT") && (
															<>
																<BasicButton label="직권취소" className="list-button btn-cancel" onClick={() => showProductOrderAdminCancelReqPopup(d.productOrder_productOrderId)}/>
																<BasicButton label="반품요청" className="list-button btn-mod" onClick={() => showProductOrderReturnReqPopup(d.productOrder_productOrderId)}/>
															</>
														) }

														{/* currentClaim.return.claimStatus가 RETURN_REQUEST 이면 [반품승인], [반품보류] [반품거부(철회)] */}
														{(d.currentClaim_return_claimStatus === "RETURN_REQUEST") && (
															<>
																<BasicButton label="반품승인" className="list-button btn-mod" onClick={() => productOrderReturnApprove(d.productOrder_productOrderId)}/>
																{d.currentClaim_return_holdbackStatus === "HOLDBACK" ? (
																	<BasicButton label="반품보류 해제" className="list-button btn-copy" onClick={() => productOrderReturnHoldRelease(d.productOrder_productOrderId)}/>
																) : (
																	<BasicButton label="반품보류" className="list-button btn-copy" onClick={() => showProductOrderReturnHoldPopup(d.productOrder_productOrderId)}/>
																)}
																<BasicButton label="반품거부(철회)" className="list-button btn-cancel" onClick={() => productOrderReturnRejectPopup(d.productOrder_productOrderId)}/>
															</>
														) }
														{/* 반품 보류면 [반품보류해제] 를 표시해야 하는데.. 반품 보류가 상태가 없는데.... 데이터를 봐야 할듯.. */}
													</>
												) : (<></>)}
												
											</>
										</div>


										<div className="th">배송</div>
										<div className="td">
											{d.delivery_deliveryMethod}
										</div>

										{getOrigDataInfo(d).currentClaim && (
											<>
												<div className="th">클레임</div>
												<div className="td">
												</div>
											</>
										)}


									</div>
								</Fragment>
							))}

							<div className="mg-t-20" />

						</div>

						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="닫기" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
							</div>
						</div>

					</div>

				</div>
			</div>

			{/* 구매확정 처리 팝업 */}
			<SendCompleteModal
				isOpen={isOpenCompletePopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "complete")}
				data={data}
				initData={completeData}
			/>
			{/* 발송 처리 (배송준비중) 팝업 */}
			<SendReadyModal
				isOpen={isOpenSendReadyPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "sendReady")}
				initData={sendReadyInfo.current}
			/>
			{/* 발송 지연 처리 팝업 */}
			<SendDelayModal
				isOpen={isOpenDelayPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "delay")}
				initData={delayInfo}
			/>
			{/* 취소 처리 팝업 */}
			<OrderCancelReqModal
				isOpen={isOpenCancelReqPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "cancelReq")}
				initData={cancelReqInfo.current}
			/>
			{/* 직권 취소 처리 팝업 */}
			<OrderAdminCancelReqModal
				isOpen={isOpenAdminCancelReqPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "adminCancelReq")}
				initData={adminCancelReqInfo.current}
			/>
			{/* 반품 요청 팝업 */}
			<OrderReturnReqModal
				isOpen={isOpenReturnReqPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "returnReq")}
				initData={returnReqInfo.current}
			/>
			{/* 반품 보류 팝업 */}
			<OrderReturnHoldModal
				isOpen={isOpenReturnHoldPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "returnHold")}
				initData={returnHoldInfo.current}
			/>
			{/* 반품 거부(철회) 팝업 */}
			<OrderReturnRejectModal
				isOpen={isOpenReturnRejectPopup}
				onClose={(sCnt, fCnt) => afterOrderProcess(sCnt, fCnt, "returnReject")}
				initData={returnRejectInfo.current}
			/>
			{/* 배송콜백 처리 팝업(출고완료,배송완료) */}
			<DeliveryCallbackModal
				isOpen={isOpenDeliveryCallbackPopup}
				onClose={(result) => {
					setIsOpenDeliveryCallbackPopup(false);
					deliveryCallbackInfo.current = null;
					if(result === "OK") getOrderDetail(initData);
				}}
				initData={deliveryCallbackInfo.current}
			/>
		</ReactModal>
	);
}

export default OrderDetailModal;
